module.exports = __webpack_public_path__ + "static/media/market_pulse_survey_response.b131531e.png";